module.exports = __webpack_public_path__ + "static/media/mobile-feature.744a8a5c.svg";